/* @flow */

import { getURLWithoutParams } from '../connection';
import { parseURLParams } from '../util';
import { checkIfNotReactNative } from '../util/checkOS';

/**
 * Retrieves the JSON Web Token (JWT), if any, defined by a specific
 * {@link URL}.
 *
 * @param {URL} url - The {@code URL} to parse and retrieve the JSON Web Token
 * (JWT), if any, from.
 * @returns {string} The JSON Web Token (JWT), if any, defined by the specified
 * {@code url}; otherwise, {@code undefined}.
 */
export function parseJWTFromURLParams(url: URL = window.location) {
    return parseURLParams(url, true, 'search').mt;
}

/**
 * Retrieves the JSON Web Token (JWT), if any, defined by a specific
 * {@link URL}.
 *
 * @param {URL} url - The {@code URL} to parse and retrieve the JSON Web Token
 * (JWT), if any, from.
 * @returns {string} The JSON Web Token (JWT), if any, defined by the specified
 * {@code url}; otherwise, {@code undefined}.
 */
export function parseURLParamsBAck(url: URL) {
    return parseURLParams(url, true, 'search').goBack;
}

/**
 * Retrieves the JSON Web Token (JWT), if any, defined by a specific
 * {@link URL}.
 *
 * @param {URL} url - The {@code URL} to parse and retrieve the JSON Web Token
 * (JWT), if any, from.
 * @returns {string} The JSON Web Token (JWT), if any, defined by the specified
 * {@code url}; otherwise, {@code undefined}.
 */
export function parseRETURNURLFromURLParams(url: URL) {
    return parseURLParams(url, true, 'search').return_url ?? parseURLParams(url, true, 'search').return_url;
}

/**
 * Returns the user name after decoding the jwt.
 *
 * @param {Object} state - The app state.
 * @returns {string}
 */
export function getJwtName(state: Object) {
    const { user } = state['features/base/jwt'];

    return user?.name;
}

export const removeUrlState = () => (dispatch: Dispatch<any>, getState: Function) => {
    const { locationURL } = getState()['features/base/connection'];

    if (checkIfNotReactNative()) {
        const { history, location } = window;

        if (history
            && location
            && history.length
            && typeof history.replaceState === 'function' && Boolean(parseURLParams(locationURL, true, 'search')?.mt
            || parseURLParams(locationURL, true, 'search')?.access_token || parseURLParams(locationURL, true, 'search')?.pcode)) {
            const replacement = getURLWithoutParams(location);
            const isInIframe = window.self !== window.top;

            if (location !== replacement && !isInIframe) {
                history.replaceState(
                history.state,
                (document && document.title) || '',
                replacement);
            }
        }
    }
};
